import React, { Component } from 'react';
import { Button, Icon, Menu, MenuItem, Popover } from 'core/components';
import { FiDatabase, FiTrash2 } from 'react-icons/fi';
import { api } from 'core/util';

export default class CompanyActionsMenu extends Component {
  state = {
    isOpen: false
  };

  handleInteraction = (isOpen) => {
    this.setState({ isOpen });
  };

  handleSyncCompanyDb = () => {
    const { companyId } = this.props;
    return api.post(`/api/ui/sudo/companies/${companyId}/sync-db`);
  };

  handleClearDictionaryCache = () => {
    const { companyId } = this.props;
    return api.post(`/api/ui/sudo/companies/${companyId}/clear-dictionary-cache`);
  };

  get optionsMenu() {
    return (
      <Menu>
        <MenuItem icon={FiDatabase} text="Resync Company DB" onClick={this.handleSyncCompanyDb} />
        <MenuItem icon={FiTrash2} text="Clear Dictionary Cache" onClick={this.handleClearDictionaryCache} />
      </Menu>
    );
  }

  render() {
    const { isOpen } = this.state;
    return (
      <Popover
        isOpen={isOpen}
        content={this.optionsMenu}
        onInteraction={this.handleInteraction}
        position="bottom-right"
      >
        <Button
          text="Actions"
          minimal
          rightIcon={<Icon icon="caret-down" iconSize={16} mx="-2px" />}
          active={isOpen}
          ariaIsMenuButton
          aria-haspopup="menu"
        />
      </Popover>
    );
  }
}
